import { useState } from 'react';

/**
 * First-login entrance animation flag. We "arm" it when the user initiates a
 * sign-in (both the Microsoft redirect and the password form), then "consume"
 * it on the first authenticated screen that shows totals/charts — so the cards
 * and charts play their entrance once per login and stay still on later
 * navigations. A plain refresh of an existing session never arms it, so it
 * only replays after a real logout → login. localStorage (not session) is used
 * so the flag survives the sign-in redirect round trip.
 */
const KEY = 'ciimar-intro';

export function armIntro(): void {
  try {
    localStorage.setItem(KEY, 'pending');
  } catch {
    /* storage may be unavailable */
  }
}

/**
 * True only on the first mount after a sign-in. Consumes the flag so the next
 * mount (navigation) returns false until the next login arms it again.
 */
export function useIntro(): boolean {
  const [intro] = useState(() => {
    try {
      if (localStorage.getItem(KEY) === 'pending') {
        localStorage.removeItem(KEY);
        return true;
      }
    } catch {
      /* storage may be unavailable */
    }
    return false;
  });
  return intro;
}
